var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("tenantProjects.final-docs.history"))),
      ]),
      _vm._v(" "),
      _c("HKLTable", {
        attrs: { dataSource: _vm.dataSource, columns: _vm.columns },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }